import StackKit from "@/shared/components/kit/stack";
import { useState } from "react";
import Content from "./content";
import Detail from "./detail";
import Correction from "./correction";
import ResultOfInformationReview from "./resultOfInformationReview";
import { Grid } from "@mui/material";
import EditInformationReview from "./editInformationReview";
import { BalanceData, CreditDataMain } from "@/types/api/user/home.type.data";
import ImgStaticCard from "@/shared/components/common/imgStaticCard/imgStaticCard";
import CustomSelectNormal from "@/shared/components/common/select/selectNormal";
import BoxKit from "@/shared/components/kit/box";
import { numberSeparator } from "@/hooks/useThousandsSeparator";
import CardBoxLayout from "@/modules/merchant/layout/cardBoxLayout";

/**
 * AwaitingApproval
 *
 * کامپوننت مدیریت و نمایش وضعیت اعتبارسنجی کاربر بر اساس وضعیت‌های مختلف.
 * این کامپوننت شامل:
 * - نمایش محتوا بر اساس وضعیت اعتبارسنجی کاربر (در انتظار تایید، ویرایش، موفق، ناموفق و درخواست اصلاح چک).
 * - مدیریت نمایش جزئیات یا ویرایش جزئیات با استفاده از state محلی.
 * - نمایش موجودی نقدی و اعتباری کاربر با قابلیت انتخاب از طریق منوی کشویی.
 * - نمایش کارت‌های تصویری مرتبط با موجودی یا اطلاعات کاربر.
 *
 * @param {Object} props
 * @param {CreditDataMain | undefined} [props.userInquiry] داده‌های اعتبار کاربر
 * @param {BalanceData | undefined} [props.walletBalance] موجودی کیف پول کاربر
 *
 * @component
 * @returns JSX.Element
 */

const AwaitingApproval = ({userInquiry,walletBalance,}: {userInquiry?: CreditDataMain | undefined;walletBalance?: BalanceData | undefined;}) => {
  const [detail, setDetail] = useState(false);
  const [editDetail, setEditDetail] = useState(false);
  const [selected, setSelected] = useState("all");

  const dataOptionSelect = [
    {
      label: `موجودی نقدی(ریال)  : ${numberSeparator(walletBalance?.balance) ?? 0}`,
      value: "all",
    },
    {
      label: `موجودی اعتباری(ریال) : ${
        numberSeparator(walletBalance?.credit?.amount) ?? 0
      }`,
      value: "cash_20card",
    },
  ];

  const renderContent = () => {
    if ((
          userInquiry?.status_manager_answer === "await_admin" ||
          userInquiry?.status_manager_answer === "pending" ||
          userInquiry?.status_manager_answer === "await_admin_check" ||
          userInquiry?.status_manager_answer === "accept-data-check"
        ) && !detail) {
      return (<Content setEditDetail={setEditDetail} setDetail={setDetail} userInquiry={userInquiry}/>);
    }

    if (userInquiry?.status_manager_answer === "edit") {
      return <Correction userInquiry={userInquiry} />;
    }

    if (detail) {
      return <Detail userInquiry={userInquiry} setDetail={setDetail} />;
    }

    if ( userInquiry?.status_manager_answer === "accept" || userInquiry?.status_manager_answer === "await_accept_from_user") {
      return (<ResultOfInformationReview status="موفق" isSuccess userInquiry={userInquiry}/>);
    }
    if (userInquiry?.status_manager_answer === "reject") {
      return (<ResultOfInformationReview status="ناموفق" userInquiry={userInquiry} />);
    }
    if (userInquiry?.status_manager_answer === "edit-data-check") {
      return <EditInformationReview userInquiry={userInquiry} />;
    }
    return null;
  };

  return (
    <StackKit className="rounded-2xl w-full min-h-[486px]">
      <Grid direction={'column-reverse'}  sx={{ justifyContent:'center' , alignItems:'center'}} container gap={10}>
        <Grid size={ userInquiry?.status_manager_answer === "await_admin_check" ? 12 : 9}>
          <CardBoxLayout sx={{background: "linear-gradient(97.77deg, rgba(0, 0, 0, 0.4) -9.73%, rgba(23, 23, 23, 0.281106) 16.04%, rgba(115, 103, 240, 0.25) 50.23%, rgba(65, 65, 65, 0.231942) 87.66%, rgba(0, 0, 0, 0.16) 109.42%)", minHeight: "486px",}}>
            {renderContent()}
          </CardBoxLayout>
        </Grid>
          {userInquiry?.status_manager_answer === "await_admin_check" || userInquiry?.status_manager_answer === "await_accept_from_user" ? null : (
            <StackKit direction={'row'} justifyContent={'center'} sx={{ width: "100%", mt: { md: 3, sm: 2, xs: 2 },height:"50px !important"}}>
              <BoxKit >
                <CustomSelectNormal label="" value={selected} onChange={(e) => setSelected(e.target.value)} options={dataOptionSelect} getOptionLabel={(item) => item.label} getOptionValue={(item) => item.value} width="100%"/>
              </BoxKit>

              <BoxKit className="!h-[20px]" sx={{ width: { lg: "200px", md: "50%", sm: "100%", xs: "100%" }, mt: { lg: 2, md: 0, sm: 2, xs: 2 }, display: "flex", justifyContent: "center",}}>
                <ImgStaticCard imgSlider1="/card-out-simple-flat2.png" imgSlider2="/slide2.jpg" widthBox="80%"/>
              </BoxKit>
            </StackKit>
          )}
      </Grid>
    </StackKit>
  );
};

export default AwaitingApproval;
